import type { FC, ComponentProps, ReactNode } from "react";
import { memo } from "react";
import { SxProps, Stack } from "@mui/material";
import styles from "./styles";

type Props = ComponentProps<typeof Stack> & {
  children?: ReactNode;
};

const Row: FC<Props> = ({ children, sx, ...rest }) => (
  <Stack direction="row" sx={(Array.isArray(sx) ? [styles, ...sx] : sx ? [styles, sx] : [styles]) as SxProps} {...rest} className="RlxRow">
    {children}
  </Stack>
);

Row.displayName = "Row";

export default memo(Row);
